'use es6';

import { createContext } from 'react';
import UIIconCircle from 'UIComponents/icon/UIIconCircle';
import { BATTLESHIP } from 'HubStyleTokens/colors';
import { jsx as _jsx } from "react/jsx-runtime";
const AvatarComponent = () => /*#__PURE__*/_jsx(UIIconCircle, {
  name: "blank",
  size: 11,
  color: BATTLESHIP,
  borderWidth: 0,
  backgroundColor: BATTLESHIP
});
AvatarComponent.displayName = 'DefaultAvatarComponent';
const MessageHistoryContext = /*#__PURE__*/createContext({
  AvatarComponent
});
export default MessageHistoryContext;